/**
 * Morphing disclosure (jh3y QwyYoVr): content-height measurement + exclusive open.
 */
(function () {
  function measureDetail(detail) {
    const content = detail.querySelector('.accordion__content');
    if (!content) return;

    const wasOpen = detail.hasAttribute('open');

    if (!wasOpen) {
      detail.setAttribute('open', '');
    }

    detail.offsetHeight;

    const height = Math.ceil(content.getBoundingClientRect().height);
    detail.style.setProperty('--content-height', `${height}px`);

    if (!wasOpen) {
      detail.removeAttribute('open');
    }
  }

  function measureMorphingDisclosure(container) {
    const detailsList = container.querySelectorAll(':scope > details');
    if (!detailsList.length) return;

    const originalVisibility = container.style.visibility;
    container.style.visibility = 'hidden';

    detailsList.forEach(measureDetail);

    container.style.visibility = originalVisibility;
  }

  function closeSiblingPanels(container, openDetail) {
    container.querySelectorAll(':scope > details[open]').forEach((detail) => {
      if (detail !== openDetail) {
        detail.removeAttribute('open');
      }
    });
  }

  function enforceExclusiveOpen(container) {
    const openPanels = container.querySelectorAll(':scope > details[open]');
    if (openPanels.length <= 1) return;

    openPanels.forEach((detail, index) => {
      if (index > 0) detail.removeAttribute('open');
    });
  }

  function bindMorphingDisclosure(container) {
    if (container.dataset.morphingBound === 'true') return;
    container.dataset.morphingBound = 'true';

    container.querySelectorAll(':scope > details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;

        closeSiblingPanels(container, detail);
        measureDetail(detail);
      });
    });
  }

  function initContainer(container) {
    measureMorphingDisclosure(container);
    bindMorphingDisclosure(container);
    enforceExclusiveOpen(container);
  }

  function measureAll() {
    document.querySelectorAll('.morphing-disclosure').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureAll);
  } else {
    measureAll();
  }

  window.addEventListener('load', measureAll);
  document.fonts?.ready?.then(measureAll);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureAll, 150);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.morphing-disclosure').forEach(initContainer);
  });
})();
